import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { wacToken } from '@/libraries/design/foundations';
import { Cross } from '@/libraries/wpl/foundations/src/icons/basic/cross';

const searchButtonStyle = css({
	background: 'transparent',
	border: 0,
	cursor: 'pointer',
	padding: 0,
	display: 'flex',
	alignItems: 'center',
	color: wacToken('color.neutral.dark100'),
	'&:hover': {
		color: wacToken('color.neutral.dark100'),
	},
});

const searchIconStyle = css({
	color: wacToken('color.primary.black'),
	borderRadius: '50%',
	height: 'auto',
});

export const UniformSearchCloseButton = (props: {
	readonly onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
	let searchCloseLabel = 'Clear search';
	try {
		const intl = useIntl();
		searchCloseLabel = intl.formatMessage({
			id: 'SearchCloseButton.label',
			defaultMessage: 'Clear search',
		});
	} catch (e) {
		// IntlProvider not available, use default
	}
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
		createAnalyticsEvent({
			eventType: 'ui',
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'clearSearch',
			source: 'searchWithFilters',
			attributes: { label: searchCloseLabel },
		}).fire();
		props.onClick(e);
	};

	return (
		<button
			type="button"
			css={searchButtonStyle}
			onClick={handleClick}
			id="search-close-icon"
			aria-label={searchCloseLabel}
		>
			<Cross size={'16'} css={searchIconStyle} />
		</button>
	);
};
